module.exports = __webpack_public_path__ + "img/logo-m2n.2f5f3951.svg";